import React from "react";
import Banner from "./Home/Banner";
import JobCategories from "./Home/JobCategories";
import FeaturedJobs from "./Home/FeaturedJobs";
import FeaturedCompanies from "./Home/FeaturedCompanies";
import useFetch from "../useFetch";
import Seo from "./Common/Seo";

const Home = () => {
  const { response, isLoading } = useFetch(process.env.REACT_APP_BASE_API_URL + "/home");
  const home = response?.home;

  return (
    <div className="page-wrapper">
      <Seo
        title="Epic-Jobs | Moving Careers and Companies Forward"
        description="Search jobs, discover companies, upload resumes, and manage hiring workflows with Epic-Jobs."
      />
      <div className="main-content">

        <Banner home={home} isLoading={isLoading} />

        <JobCategories categories={home?.categories ?? []} stats={home?.stats} />

        <FeaturedJobs jobs={home?.featured_jobs ?? []} isLoading={isLoading} />

        <FeaturedCompanies companies={home?.companies ?? []} />

      </div>
    </div>
  );
};

export default Home;
